import { ConversationalChatVisibility } from '@klant/conversational-connector/klant-conversational-connector.model';

import { Component, OnInit, output, inject } from '@angular/core';

import { ApContentService } from '@ap/content';

import content from './conversational-link.content.json';

@Component({
    selector: 'conversational-link',
    templateUrl: './conversational-link.component.html',
    standalone: false
})
export class ConversationalLinkComponent implements OnInit {
    private readonly contentService = inject(ApContentService);

    public changeConversationalStatus$ = output<ConversationalChatVisibility>();

    public ngOnInit(): void {
        this.contentService.addContentItems(content);
    }

    public onOpenConversational(): void {
        this.changeConversationalStatus$.emit(ConversationalChatVisibility.OPEN);
    }
}
